<template>
  <div>
    <div>
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartSelect
            label="Plano Contratado"
            itemText="name"
            itemValue="plan"
            :items="plans"
            v-model="selectedPlan"
            name="plan"
            :error="errors.first('plan')"
            placeholder="Informe o Plano Contratado"
            v-validate="'required'"
            @change="loadPlanInfo($event, 'plan')"
            :noDataText="
              term.payment.storeId > 0
                ? 'Não há planos disponíveis do produto informado para essa loja.'
                : 'Para selecionar o plano, informe a loja.'
            "
          />
        </div>
        <!-- <div class="w-full "> -->
        <div class="lg:col-4" style="margin-top: -20px">
          <SmartTitle heading="2" weight="medium" class="p-1"
            >Fidelização</SmartTitle
          >
          <v-radio-group
            class="m-0"
            v-model="value.loyalty"
            :mandatory="false"
            row
            @change="loyaltyChange"
            :id="'loyalty'"
            :name="'loyalty'"
            v-validate="isSomenteFidelizado ? '' : 'required'"
            :error="errors.first('loyalty')"
          >
            <v-radio
              label="Sim"
              :value="true"
              v-bind:disabled="isSomenteFidelizado"
            />
            <v-radio
              label="Não"
              :value="false"
              v-bind:disabled="isSomenteFidelizado"
            />

            <div class="smart-feedback" v-if="errors.has('loyalty') || success">
              {{ errors.first("loyalty") || success }}
            </div>
          </v-radio-group>
        </div>
        <div
          class="lg:col-2 pt-3"
          v-bind:style="{
            'margin-top': !isFidelizacaoAparelho ? '-35px' : '0px',
          }"
        >
          <div v-if="isComFidelizacao">
            <SmartTitle
              heading="2"
              weight="medium"
              class="p-1"
              v-if="!isFidelizacaoAparelho"
              v-show="value.loyalty"
              >Fidelização</SmartTitle
            >

            <SmartCheckbox
              value="Plano"
              name="planLoyalty"
              id="planLoyalty"
              class="high-p"
              v-model="planLoyalty"
              v-show="
                value.loyalty && (isSomenteFidelizado || isFidelizacaoPlano)
              "
              v-bind:disabled="isSomenteFidelizado"
              :error="errors.first('planLoyalty')"
              v-validate="
                value.loyalty &&
                (isSomenteFidelizado || isFidelizacaoPlano) &&
                !value.telephoneLoayalty
                  ? 'required:true'
                  : ''
              "
            />
            <!-- v-if="!isSomenteFidelizado" -->

            <SmartCheckbox
              value="Aparelho/Acessórios"
              name="telephoneLoayalty"
              id="telephoneLoayalty"
              class="high-p"
              v-model="telephoneLoayalty"
              v-show="value.loyalty && isFidelizacaoAparelho"
              :error="errors.first('telephoneLoayalty')"
              v-validate="
                value.loyalty && isFidelizacaoAparelho && !value.planLoyalty
                  ? 'required:true'
                  : ''
              "
            />

            <!-- v-if="isFidelizacaoAparelho" -->
            <!-- v-validate="!value.planLoyalty?'required:true':''" -->
          </div>
        </div>
        <!-- </div> -->
      </SmartRow>
    </div>

    <!-- Protocolo de Atendimento e Nr. Telefone GSM -->
    <SmartRow
      class="form flex sub-form justify-between flex-nowrap flex-row pl-1 pt-3"
    >
      <div class="w-full">
        <SmartInput
          label="Nº de Protocolo de Atendimento"
          placeholder="Informa o Nº de Protocolo de Atendimento"
          id="protocolNumber"
          name="protocolNumber"
          v-model="value.protocolNumber"
          v-validate="'required'"
          :error="errors.first('protocolNumber')"
          :mask="'#'.repeat(50)"
        />
      </div>
      <div class="w-full">
        <SmartInput
          label="Nº de Tel (GSM)"
          id="phone_smp"
          :mask="['(##) ####-####', ' (##) #####-####']"
          placeholder="Informe o Nº de Tel (GSM)"
          v-model="value.phone"
          name="phone_smp"
          v-validate="'required|celPhone'"
          :error="errors.first('phone_smp')"
        />
      </div>
    </SmartRow>

    <SmartRow
      class="form flex sub-form justify-between flex-nowrap flex-row pl-1 pt-3"
      v-if="!isTransferenciaTitularidade"
    >
      <div class="w-full">
        <SmartInput
          label="ICCID/TIM Chip"
          placeholder="Informe o ICCID/TIM Chip"
          id="iccid"
          name="iccid"
          v-model="value.iccid"
          v-validate="{ required: true, min: 19 }"
          minlength="19"
          :mask="'#'.repeat(20)"
          :error="errors.first('iccid')"
        />
      </div>
    </SmartRow>

    <div v-if="value.loyalty && !isTransferenciaTitularidade">
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartInput
            label="Valor do Plano Contratado"
            placeholder="Informe o Valor do Plano Contratado"
            id="contratedPrice"
            name="contratedPrice"
            v-model="value.plan.planValue"
            disabled
          />
        </div>

        <div class="w-full">
          <SmartInput
            v-if="value.loyalty"
            label="Valor do Novo Plano Contratado com desconto*"
            placeholder="Informe o Valor do Plano Contratado com desconto"
            id="servicePromotionalPrice"
            name="servicePromotionalPrice"
            v-model="value.plan.promotionalValue"
            disabled
          />
        </div>
      </SmartRow>
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartInput
            label="Pacote de dados"
            placeholder="Informe o Pacote de Dados"
            id="dataPackage"
            name="dataPackage"
            v-model="value.plan.dataPackage"
            disabled
          />
        </div>
        <div class="w-full">
          <SmartInput
            v-if="!term.posVenda.isMudancaPlano"
            label="Serviços adicionais (Opcional)"
            placeholder="Informe os Serviços adicionais"
            id="additionalServices"
            name="additionalServices"
            v-model="value.additionalServices"
            @change="onChangeAdditionalServices"
          />
          <!-- @change="additionalServicesChange" -->
        </div>
      </SmartRow>
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartInput
            v-if="!term.posVenda.isMudancaPlano"
            :disabled="value.additionalServices.trim() === ''"
            label="Valor do serviço adicional (Opcional)"
            placeholder="Informe o Valor do serviço adicional"
            id="additionalPrice"
            name="additionalPrice"
            type="money"
            v-model.lazy="value.additionalPrice"
          />
        </div>
        <div class="w-full" />
      </SmartRow>
    </div>
    <div v-else-if="!isTransferenciaTitularidade">
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartInput
            label="Valor do Plano Contratado"
            placeholder="Informe o Valor do Plano Contratado"
            id="contratedPrice"
            name="contratedPrice"
            v-model="value.plan.planValue"
            disabled
          />
        </div>

        <div class="w-full">
          <SmartInput
            label="Pacote de dados"
            placeholder="Informe o Pacote de Dados"
            id="dataPackage"
            name="dataPackage"
            v-model="value.plan.dataPackage"
            disabled
          />
        </div>
      </SmartRow>
      <SmartRow
        class="
          form
          flex
          sub-form
          justify-between
          flex-nowrap flex-row
          pl-1
          pt-3
        "
      >
        <div class="w-full">
          <SmartInput
            v-if="!term.posVenda.isMudancaPlano"
            label="Serviços adicionais (Opcional)"
            placeholder="Informe os Serviços adicionais"
            id="additionalServices"
            name="additionalServices"
            v-model="value.additionalServices"
            @change="onChangeAdditionalServices"
          />
        </div>

        <div class="w-full">
          <SmartInput
            v-if="!term.posVenda.isMudancaPlano"
            :disabled="value.additionalServices.trim() === ''"
            label="Valor do serviço adicional (Opcional)"
            placeholder="Informe o Valor do serviço adicional"
            id="additionalPrice"
            name="additionalPrice"
            type="money"
            v-model.lazy="value.additionalPrice"
          />
        </div>
      </SmartRow>
    </div>

    <div class="mb-4" v-if="!isTransferenciaTitularidade">
      * Os valores estão sujeitosa reajustes, conforme dispostosn no Contrato
      STFC e no regulamento da oferta
    </div>

    <PortabilityElement
      v-if="!isTransferenciaTitularidade && term.tipoVenda !== 'posVenda'"
      v-model="portability"
      ref="portability"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// import plans from "constants/plans";

export default {
  name: "ServiceTypeElement",
  data() {
    return {
      portability: {},
      plans: [],
      plansVoip: [],
      selectedPlan: "",
      value: this.model,
      planLoyalty: false,
      telephoneLoayalty: false,
    };
  },
  watch: {
    portability() {
      this.value.portability = this.portability;
    },
    value(v) {
      this.$emit("change", this.value);
    },
    planLoyalty(v) {
      this.value = { ...this.value, ...{ planLoyalty: v } };
    },
    telephoneLoayalty(v) {
      this.value = { ...this.value, ...{ telephoneLoayalty: v } };
    },
  },
  components: {
    PortabilityElement: () => import("./PortabilityElement.vue"),
  },
  model: {
    prop: "model",
    event: "change",
  },
  props: {
    model: {}, // eslint-disable-line
    transferenciaTitularidade: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$root.$on("atualizarplanos", (d) => {
      this.plans = d;
    });

    this.$root.$on("atualizarplanosSTFC", (d) => {
      this.plans = d;
    });
  },
  computed: {
    ...mapGetters({
      term: "term/term",
    }),
    isTransferenciaTitularidade() {
      return this.transferenciaTitularidade;
    },
    isComFidelizacao() {
      return (
        this.value.plan.somenteFidelizado === "SIM" ||
        this.value.plan.fidelizacaoPlano === "SIM" ||
        this.value.plan.fidelizacaoAparelho === "SIM"
      );
      return true;
    },
    isSomenteFidelizado() {
      return (
        this.value.plan.somenteFidelizado === "SIM" ||
        (this.value.plan.somenteFidelizado !== "SIM" &&
          this.value.plan.fidelizacaoPlano !== "SIM" &&
          this.value.plan.fidelizacaoAparelho !== "SIM")
      );
    },
    isFidelizacaoPlano() {
      return (
        this.value.plan.somenteFidelizado === "SIM" ||
        this.value.plan.fidelizacaoPlano === "SIM"
      );
    },
    isFidelizacaoAparelho() {
      return this.value.plan.fidelizacaoAparelho === "SIM";
    },
    isCorporativo() {
      return this.term.plan === "corporativo";
    },
  },
  methods: {
    loyaltyChange(e) {
      if (!e) {
        this.planLoyalty = false;
        this.telephoneLoayalty = false;
        this.$emit("change", this.value);
      }
    },
    loadPlanInfo(selected, variable) {
      const plan = this.plans.find((e) => e.name === selected);

      this.value[variable] = this.value.plan || {};
      this.value[variable] = plan;

      this.value.loyalty = null;
      this.planLoyalty = false;
      this.telephoneLoayalty = false;

      if (this.value.plan.somenteFidelizado === "SIM") {
        this.value.loyalty = true;
        this.planLoyalty = true;
      }

      this.$emit("change", this.value);
    },
    async isValid() {
      let portabilityValidated = true;
      if (this.$refs.portability) {
        portabilityValidated = await this.$refs.portability.isValid();
      }
      await this.$validator.validateAll();
      return (
        Object.keys(this.fields).every((field) => this.focusOnError(field)) &&
        portabilityValidated
      );
    },
    focusOnError(field) {
      const isValid = this.fields[field].valid;
      if (!isValid) {
        document.getElementsByName(field)[0].focus();
      }
      return isValid;
    },
    onChangeAdditionalServices(e) {
      if (this.value.additionalServices.trim() === "") {
        this.value.additionalPrice = 0;
      }
    },
  },
  beforeMount() {
    const copy = JSON.parse(JSON.stringify(this.value.portability));
    this.portability = copy;
    this.selectedPlan = this.value.plan.name;
    this.planLoyalty = this.value.planLoyalty;
    this.telephoneLoayalty = this.value.telephoneLoayalty;
    this.selectedPlan = this.value.plan.name;
  },
};
</script>

<style lang="scss" scoped>
.form {
  .smart-input__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
  .smart-select__wrapper {
    margin-bottom: $spacing-margin-xsmall;
  }
}

.smart-feedback {
  font-family: $font-family-01;
  color: $color-ui-danger;
  margin-top: $spacing-margin-xxxsmall;
  align-self: flex-end;
  font-size: $font-size-paragraph;
}
</style>
